import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    divider: {
        border: 0,
        backgroundColor: theme.colors.gray[2],
        opacity: 1,
        height: "1px",
        width: "100%",
        margin: 0,
    },
}))
